import { createSelector } from 'reselect';

const columns = state => state.generalReports.columns;

const loading = state => state.generalReports.loading;

const progress = state => state.generalReports.progress;

const downloadInProgress = state => state.generalReports.downloadInProgress;

const internalData = state => state.generalReports.data;

export const data = createSelector(internalData, data => {
  if (!data) return null;
  // flatten data indexed by page
  return Object.values(data).flat();
});

export const columnsByKey = createSelector(columns, columns =>
  (columns || []).reduce((acc, column) => {
    acc[column.attribute] = column;
    return acc;
  }, {})
);

export const defaultColumns = createSelector(columns, columns => (columns || []).filter(c => c.default));

export const defaultColumnKeys = createSelector(defaultColumns, defaultColumns => defaultColumns.map(c => c.attribute));

export default {
  columnsByKey,
  defaultColumnKeys,
  loading,
  data,
  progress,
  downloadInProgress
};
